import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Formik } from 'formik';
// import { resetEmail } from '../../../../../store/modules/auth';
import { schema2 } from '../../extras/validation/schema';
import ArrowBackStandar from '../../../../../components/ArrowBack/ArrowBackStandar';
import Footer from '../../Footer';
//import '../../../index.scss';
import './RecoverPassword.scss';
/* import { withFirebase } from 'react-redux-firebase';
 */import ButtonBase from '../../../../../components/Buttons/ButtonBase';
import { Link } from 'react-router-dom';
import { RECOVER_PASSWORD, SIGNIN } from '../../../../../routes';
import {doPasswordReset} from '../../../../../configs/environments/firebase/firebaseApp';
import { isMobile } from 'react-device-detect';
const lawyerVerificationEmail = '/img/recover-password/persona-1.svg';

const styles = () => ({
  colorGrayIcon: {
    color: '#c1c1c1',
    padding: 0
  },
  TextField: {
    maxWidth: '336px'
  },
  img: {
    position: 'absolute',
    left: '50%',
    top: 8,
    transform: 'translate(-50%)'
  }
});

class RecoverPassword extends Component {
  state = {
    showPassword: false,
    forgetPassword: false,
    open: false,
    showModal: false,
    email: ''
  };


  changeState = () => {
    this.setState({ open: false });
  };

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  handlerBack = () => {
    this.props.history.push('/');
  };
  renderFormResetPassword = props => {
    const {
      values,
      handleChange,
      handleSubmit,
      touched,
      handleBlur,
      errors,
    } = props;
    const { classes } = this.props;
    return (
      <form className="container-box">

        <div className="recoverPass_header">
          <div className="recoverPass_icons">
            <ArrowBackStandar
              text=" regresar"
            />
            <figure className="recoverPass_close">
             {isMobile ? (<img src="/img/icons/close.svg" alt="close" />) :''}

            </figure>
          </div>
          <figure className="recoverPass_logo">
            <img src="/img/Logo-box.svg" alt="logo" />
          </figure>

          <p className="recoverPass_title">Restablecer tu contraseña</p>


        </div>


        <div className="recoverPass_body">
          <p className="recoverPass_text">
            Si has olvidado tu contraseña, podemos enviarte un correo a la
            dirección con la que te registraste en Contacta Abogado
            y podrás restablecerla.
          </p>
        <div>
          <TextField
            label="Correo electrónico"
            type="email"
            id="email"
            variant="outlined"
            classes={{ root: classes.TextField }}
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.email}
            helperText={touched.email && errors.email ? errors.email : ''}
            error={touched.email && errors.email ? true : false}
          />
        </div>
        <div className="horizontal-layout" style={{ marginTop: 15 }}>
          <Link to={RECOVER_PASSWORD}>
            <ButtonBase
              type="submit"
              onClick={handleSubmit}
              variant="primary"
            // disabled={!isValid}
            >
              Enviar
                </ButtonBase>
          </Link>
        </div>


        </div>

        <div className="recoverPass_footer">
        <Footer
          margin="8px 0px 16px"
          text="Si tienes cualquier duda o problema escribenos a:"
          textLink="hola@contactaabogado.com"
          linkTo=""
        />


        </div>


      </form >
    );
  };

  onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    doPasswordReset(values.email)
      .then(response => {
        this.setState({
          email: values.email,
          showModal: true
        });
      })
      .catch(error => {
        if (error.code) {
          switch (error.code) {
            case 'auth/user-not-found':
              return setErrors({ email: 'Esta cuenta no existe' });
            case 'auth/auth/argument-error':
              return setErrors({ email: 'Esta contraseña es incorrecta' });
            default:
              return setErrors({ email: 'Ocurrió un error' });
          }
        }
      });
  };

  render() {
    const { classes } = this.props;
    const incialValuesTwo = {
      email: ''
    };
    return (
      <>
        {!this.state.showModal ? (
          <Formik
            initialValues={incialValuesTwo}
            validationSchema={schema2}
            onSubmit={this.onSubmit}
            render={this.renderFormResetPassword}
          />
        ) : (
            <div className="container-box">
              <div>
                <img
                  src={lawyerVerificationEmail}
                  alt="Contacta Abogado Verificación de Correo Electrónico"
                  className={classes.img}
                />
                <div style={{ backgroundColor: '#c1c1c1', height: '125px' }}>
                  {' '}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  margin: '24px'
                }}
              >
                <p className={'title-send_email'}>
                  SE ENVIÓ UN CORREO PARA RESTABLECER TU CONTRASEÑA{' '}
                </p>
                <p className={'text-info-send'}>
                  Sigue las intruciones que ahí te indicamos para continuar con tu
                  proceso de restablecer contraseña
              </p>
                <p className={'text-main-send'}>{this.state.email}</p>
                <p className={'text-info-send'}>
                  Tienes un máximo de 24 horas para restablecer tu contraseña. Si
                  no lo haces dentrode ese periodo, tendrás que iniciar nuevamente
                  el proceso.
              </p>
                <Link to={SIGNIN}>
                  <ButtonBase
                    type="submit"
                    variant="primary"
                  // disabled={!isValid}
                  >
                    Entendido
                </ButtonBase>
                </Link>
              </div>
              <div></div>
            </div>
          )}
      </>
    );
  }
}

export default withRouter(withStyles(styles)(RecoverPassword));
